var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowitworkSv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 20)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "OpenSans",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#1a1a1a94"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 14,
    fontFamily: "OpenSans",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1a1a1a"
  }, "Find Your Address"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 30,
    fontFamily: "OpenSans, sans-serif",
    fontSize: 11,
    fill: "#1a1a1a"
  }, "Discover who owns your Building."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255, 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 0 L0 -16 L18 0 L18 18 L8 18 L8 4 L-2 4 L-2 18 L-18 18 Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: -4,
    r: 8,
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 2,
    x2: 40,
    y2: 9,
    stroke: "#1a1a1a",
    strokeWidth: 2.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 75)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "OpenSans",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#1a1a1a94"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 14,
    fontFamily: "OpenSans",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1a1a1a"
  }, "See Their Portfolio"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 30,
    fontFamily: "OpenSans, sans-serif",
    fontSize: 11,
    fill: "#1a1a1a"
  }, "Find out what else they own."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 4 L-20 -6 L-10 4 L-10 16 L-30 16 Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 2 L4 -8 L14 2 L14 16 L-6 16 Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6 L25 -1 L32 6 L32 16 L18 16 Z",
    fill: "#1a1a1a"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 130)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "OpenSans",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#1a1a1a94"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 14,
    fontFamily: "OpenSans",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1a1a1a"
  }, "Leave a Review"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 30,
    fontFamily: "OpenSans, sans-serif",
    fontSize: 11,
    fill: "#1a1a1a"
  }, "Share your experience with others."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 28)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-20,0 -18,-6 -12,-6 -16,-10 -14,-16 -20,-12 -26,-16 -24,-10 -28,-6 -22,-6",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,-6 8,-6 4,-10 6,-16 0,-12 -6,-16 -4,-10 -8,-6 -2,-6",
    fill: "#4a4a1a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20,0 22,-6 28,-6 24,-10 26,-16 20,-12 14,-16 16,-10 12,-6 18,-6",
    fill: "#6a6a2a"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 185)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 22,
    fontFamily: "OpenSans",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#1a1a1a94"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 14,
    fontFamily: "OpenSans",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#1a1a1a"
  }, "Organize Together"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 30,
    fontFamily: "OpenSans, sans-serif",
    fontSize: 11,
    fill: "#1a1a1a"
  }, "Connect with your neighbors."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -22,
    cy: -8,
    r: 6,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30 16 Q-30 0 -22 0 Q-14 0 -14 16",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 7,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 16 Q-10 -2 0 -2 Q10 -2 10 16",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: -8,
    r: 6,
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16 Q14 0 22 0 Q30 0 30 16",
    fill: "#1a1a1a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworkSv2);
export default __webpack_public_path__ + "static/media/HOWITWORKSv2.a844082a20784554873cb2c0c9e7de45.svg";
export { ForwardRef as ReactComponent };